// frontend/src/services/superAdminApi.js
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const superAdminApi = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token staff
superAdminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ============ AIRPORTS ============
export const getAirports = (page = 1, limit = 20, search = '') => 
  superAdminApi.get('/admin/airports/', { params: { page, limit, search } });

export const getAirport = (id) => 
  superAdminApi.get(`/admin/airports/${id}`);

export const createAirport = (data) => 
  superAdminApi.post('/admin/airports/', data);

export const updateAirport = (id, data) => 
  superAdminApi.put(`/admin/airports/${id}`, data);

export const deleteAirport = (id) => 
  superAdminApi.delete(`/admin/airports/${id}`);

export const resetAirportAdminPassword = (id) => 
  superAdminApi.post(`/admin/airports/${id}/reset-password`);

// ============ AIRPORT LICENSES & AGENTS ============
export const getAirportLicense = (airportId) => 
  superAdminApi.get(`/admin/airports/${airportId}/license`);

export const getAirportAgents = (airportId) => 
  superAdminApi.get(`/admin/airports/${airportId}/agents`);

export const updateAirportAgentsLimit = (airportId, data) => 
  superAdminApi.put(`/admin/airports/${airportId}/license/agents`, data);

export const removeAirportAgent = (airportId, agentId) => 
  superAdminApi.delete(`/admin/airports/${airportId}/agents/${agentId}`);

export const resetAirportLicenseKey = (airportId) => 
  superAdminApi.post(`/admin/airports/${airportId}/license/reset`);

// ============ PACKAGES ============
export const getPackages = () => 
  superAdminApi.get('/admin/airports/packages');

export const getAirportPackages = (airportId) => 
  superAdminApi.get(`/admin/airports/${airportId}/packages`);

export const updateAirportPackages = (airportId, packageIds) => 
  superAdminApi.put(`/admin/airports/${airportId}/packages`, { package_ids: packageIds });

// ============ PACKAGES CRUD (si tu as les endpoints) ============
export const createPackage = (data) => 
  superAdminApi.post('/admin/packages', data);

export const updatePackage = (packageId, data) => 
  superAdminApi.put(`/admin/packages/${packageId}`, data);

export const deletePackage = (packageId) => 
  superAdminApi.delete(`/admin/packages/${packageId}`);